import { render, staticRenderFns } from "./reply-detail.vue?vue&type=template&id=3c0bdf36&scoped=true"
import script from "./reply-detail.vue?vue&type=script&lang=js"
export * from "./reply-detail.vue?vue&type=script&lang=js"
import style0 from "./reply-detail.vue?vue&type=style&index=0&id=3c0bdf36&prod&lang=less"
import style1 from "./reply-detail.vue?vue&type=style&index=1&id=3c0bdf36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0bdf36",
  null
  
)

export default component.exports